export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getCompetencyUnitListlAction";
    Actions["GET_DETAIL"] = "getCompetencyUnitDetailAction";
    Actions["POST_DATA"] = "postCompetencyUnitAction";
    Actions["UPDATE_DATA"] = "putCompetencyUnitAction";
    Actions["DELETE_DATA"] = "deleteCompetencyUnitAction";
    Actions["CHANGE_EXPORT"] = "changeExportCompetencyUnitAction";
    Actions["DOWNLOAD"] = "downloadCompetencyUnitAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_ORDER"] = "setCompetencyUnitOrderByMutation";
    Mutations["SET_COMPETENCY_UNIT_LIST"] = "setCompetencyUnitListMutation";
    Mutations["SET_COMPETENCY_UNIT_LIST_LOADING"] = "setCompetencyUnitListLoadingMutation";
    Mutations["SET_COMPETENCY_UNIT_LIST_PAGINATION"] = "setCompetencyUnitListPaginationMutation";
    Mutations["SET_COMPETENCY_UNIT_LIST_FILTER"] = "setCompetencyUnitListFilterMutation";
    Mutations["RESET_COMPETENCY_UNIT_LIST_FILTER"] = "resetCompetencyUnitListFilterMutation";
})(Mutations || (Mutations = {}));
